export default "__VITE_ASSET__Bcc9Gsas__"